import React, { useContext } from 'react';
import { Breadcrumbs } from '@prisjakt/ui/breadcrumbs';
import { AppContext } from 'src/components/app-context';
import { Link } from 'react-router-dom';
import type { Product } from '../../../../types';
import { BreadCrumbWrapper } from './styles';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

export const ProductBreadCrumb: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IProductBreadCrumbProps>>
> = props => {
  const { product } = props;
  const { t } = useContext(AppContext);

  return (
    <BreadCrumbWrapper data-test="Breadcrumbs">
      <Breadcrumbs
        containerProps={{
          onClick: (nextPage: string) => {
            trackInternalNavigationClick({
              scope: InternalNavigationScope.BREADCRUMB,
              nextPage,
            });
          },
        }}
        lastItemClickable
      >
        <Link data-test="Crumb" to="/">
          {t('common', 'breadcrumb.home')}
        </Link>
        {product.category?.path.map(item => {
          return (
            <Link data-test="Crumb" key={item.id} to={item.pathName}>
              {item.name}
            </Link>
          );
        })}
      </Breadcrumbs>
    </BreadCrumbWrapper>
  );
};

interface IProductBreadCrumbProps {
  product: Product;
}
